import { Injectable } from '@angular/core';
import { TransferPointsSuccess } from '@features/points-transfer/store/actions/points-transfer.actions';
import { UserPreferenceActionTypes } from '@features/user-preference/store/actions/user-preference.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActionTypes } from '@rd/core/auth/store/actions/auth.actions';
import { HttpError } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { PointsSummaryApiService } from '../../services/points-summary-api/points-summary-api.service';
import * as actions from '../actions/points-summary.actions';

@Injectable()
export class PointsSummaryEffects {
  constructor(
    private actions$: Actions,
    private pointsSummaryApiService: PointsSummaryApiService,
  ) {}

  loadPointsSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        actions.PointsSummaryActionTypes.LOAD_POINTS_SUMMARY,
        TransferPointsSuccess,
      ),
      switchMap(() => {
        return this.pointsSummaryApiService.getPointsSummary().pipe(
          switchMap((pointsSummary) => {
            return [new actions.LoadPointsSummarySuccess(pointsSummary)];
          }),
          catchError((error: HttpError) =>
            of(new actions.LoadPointsSummaryFail(error)),
          ),
        );
      }),
    ),
  );

  updatePointsAccountIdSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPreferenceActionTypes.UPDATE_POINTS_ACCOUNT_ID_SUCCESS),
      map(() => new actions.LoadPointsSummary()),
    ),
  );

  pullPointsSummaryOnUserLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActionTypes.LOGIN_USER),
      take(1),
      map(() => {
        return new actions.LoadPointsSummary();
      }),
    ),
  );
}
